import React from 'react'
import pt from 'prop-types'
import { Upload } from 'lucide-react'
import { cn } from '@/lib/utils'
import { useTranslation } from 'react-i18next'
import { Spinner } from '@/components/ui/spinner'
import { buttonVariants } from '@/components/ui/button'

const FileUpload = (p) => {
  const { name, className, size, color, label, onChange, icon, loading, disabled, rounded, ...props } = p

  const { t } = useTranslation()
  const handleChange = (e) => {
    onChange(e, e.target.files)
    e.target.value = null
  }

  return (
    <div className={cn('inline-block file-upload-wrapper', className)}>
      <input name={name} id={name} type="file" onChange={handleChange} disabled={disabled} {...props} />
      <label
        htmlFor={name}
        className={cn(
          buttonVariants({ variant: 'outline', size: 'sm' }),
          (loading || disabled) && 'pointer-events-none opacity-50',
        )}
      >
        {loading ? (
          <Spinner size="sm" className="text-current" />
        ) : (
          icon
        )}{' '}
        {label || t('Organization_documents_upload_new_files_btn')}
      </label>
    </div>
  )
}

FileUpload.propTypes = {
  name: pt.string.isRequired,
  onChange: pt.func.isRequired,
  className: pt.string,
  size: pt.oneOf(['lg', 'md', 'sm']),
  color: pt.string,
  label: pt.string,
  icon: pt.node,
  loading: pt.bool,
  accept: pt.string,
  disabled: pt.bool,
  rounded: pt.bool
}
FileUpload.defaultProps = {
  size: 'sm',
  name: `fileUpload_${new Date().getTime()}`,
  icon: <Upload className="h-4 w-4" />,
  rounded: true
}

export default FileUpload
